export default () => (
  /**
   * Ícone "x" com cor cinza claro
   */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 13.9971 5.42188)"
      stroke="#BDBCBC"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 5.51172 4.30762)"
      stroke="#BDBCBC"
      strokeWidth="1.5"
    />
  </svg>
);
